var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loyalty-tier-constraint"},[_c('div',{staticClass:"loyalty-tier-dropdown-container"},[_c('am2-link-button-dropdown',{attrs:{"item-key":_vm.constraintValue,"items":_vm.predicates,"has-search":"","dropdown-style":{
        padding: '5px 0',
        width: '232px',
    }},on:{"select":function (item) { return _vm.handleConstraintDropdownSelect(item); },"searchStringChange":_vm.handleConstraintSearch}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }